/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactBookmarkFromJSON, StreemApiArtifactBookmarkToJSON, StreemApiArtifactLayoutEstimationFromJSON, StreemApiArtifactLayoutEstimationToJSON, StreemApiArtifactRoomOutcomeReportFromJSON, StreemApiArtifactRoomOutcomeReportToJSON, StreemApiArtifactTexturedMeshFromJSON, StreemApiArtifactTexturedMeshToJSON, StreemApiArtifactTranscriptionFromJSON, StreemApiArtifactTranscriptionToJSON, WallItemGPSPositionFromJSON, WallItemGPSPositionToJSON, WallItemMeshFromJSON, WallItemMeshToJSON, WallItemRecordingFromJSON, WallItemRecordingToJSON, WallItemSceneshotFromJSON, WallItemSceneshotToJSON, WallItemStreemshotFromJSON, WallItemStreemshotToJSON, } from './';
export function WallItemArtifactFromJSON(json) {
    return WallItemArtifactFromJSONTyped(json, false);
}
export function WallItemArtifactFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inResponseToWallItemId': !exists(json, 'in_response_to_wall_item_id') ? undefined : json['in_response_to_wall_item_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'artifactType': !exists(json, 'artifact_type') ? undefined : json['artifact_type'],
        'gpsPosition': !exists(json, 'gps_position') ? undefined : WallItemGPSPositionFromJSON(json['gps_position']),
        'recording': !exists(json, 'recording') ? undefined : WallItemRecordingFromJSON(json['recording']),
        'streemshot': !exists(json, 'streemshot') ? undefined : WallItemStreemshotFromJSON(json['streemshot']),
        'mesh': !exists(json, 'mesh') ? undefined : WallItemMeshFromJSON(json['mesh']),
        'transcription': !exists(json, 'transcription') ? undefined : StreemApiArtifactTranscriptionFromJSON(json['transcription']),
        'sceneshot': !exists(json, 'sceneshot') ? undefined : WallItemSceneshotFromJSON(json['sceneshot']),
        'layoutEstimation': !exists(json, 'layout_estimation') ? undefined : StreemApiArtifactLayoutEstimationFromJSON(json['layout_estimation']),
        'texturedMesh': !exists(json, 'textured_mesh') ? undefined : StreemApiArtifactTexturedMeshFromJSON(json['textured_mesh']),
        'bookmark': !exists(json, 'bookmark') ? undefined : StreemApiArtifactBookmarkFromJSON(json['bookmark']),
        'roomOutcomeReport': !exists(json, 'room_outcome_report') ? undefined : StreemApiArtifactRoomOutcomeReportFromJSON(json['room_outcome_report']),
    };
}
export function WallItemArtifactToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'in_response_to_wall_item_id': value.inResponseToWallItemId,
        'status': value.status,
        'artifact_type': value.artifactType,
        'gps_position': WallItemGPSPositionToJSON(value.gpsPosition),
        'recording': WallItemRecordingToJSON(value.recording),
        'streemshot': WallItemStreemshotToJSON(value.streemshot),
        'mesh': WallItemMeshToJSON(value.mesh),
        'transcription': StreemApiArtifactTranscriptionToJSON(value.transcription),
        'sceneshot': WallItemSceneshotToJSON(value.sceneshot),
        'layout_estimation': StreemApiArtifactLayoutEstimationToJSON(value.layoutEstimation),
        'textured_mesh': StreemApiArtifactTexturedMeshToJSON(value.texturedMesh),
        'bookmark': StreemApiArtifactBookmarkToJSON(value.bookmark),
        'room_outcome_report': StreemApiArtifactRoomOutcomeReportToJSON(value.roomOutcomeReport),
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemArtifactStatus;
(function (WallItemArtifactStatus) {
    WallItemArtifactStatus["CAPTURED"] = "CAPTURED";
    WallItemArtifactStatus["ERROR"] = "ERROR";
    WallItemArtifactStatus["FULFILLED"] = "FULFILLED";
    WallItemArtifactStatus["REJECTED"] = "REJECTED";
    WallItemArtifactStatus["STARTED"] = "STARTED";
    WallItemArtifactStatus["UNKNOWN"] = "UNKNOWN";
})(WallItemArtifactStatus || (WallItemArtifactStatus = {}));
/**
* @export
* @enum {string}
*/
export var WallItemArtifactArtifactType;
(function (WallItemArtifactArtifactType) {
    WallItemArtifactArtifactType["BOOKMARK"] = "BOOKMARK";
    WallItemArtifactArtifactType["GPSPOSITION"] = "GPS_POSITION";
    WallItemArtifactArtifactType["LAYOUTESTIMATION"] = "LAYOUT_ESTIMATION";
    WallItemArtifactArtifactType["MESH"] = "MESH";
    WallItemArtifactArtifactType["RECORDING"] = "RECORDING";
    WallItemArtifactArtifactType["ROOMOUTCOMEREPORT"] = "ROOM_OUTCOME_REPORT";
    WallItemArtifactArtifactType["SCENESHOT"] = "SCENESHOT";
    WallItemArtifactArtifactType["STREEMSHOT"] = "STREEMSHOT";
    WallItemArtifactArtifactType["TEXTUREDMESH"] = "TEXTURED_MESH";
    WallItemArtifactArtifactType["TRANSCRIPTION"] = "TRANSCRIPTION";
    WallItemArtifactArtifactType["UNKNOWN"] = "UNKNOWN";
})(WallItemArtifactArtifactType || (WallItemArtifactArtifactType = {}));
//# sourceMappingURL=WallItemArtifact.js.map